import * as ACTION from './constants';

const initialState = {
  error: null,
  meettrainer_requests: [],
  filters: [],
  isLoading: false,
  isFilterLoading: false,
  isUpdating: false,
  query: '',
  totalCount: null
};


export default function reducers(state = initialState, action) {
  switch(action.type) {
    case ACTION.MEETTRAINER_REQUEST_BASE:
      return {...initialState};
    case ACTION.MEETTRAINER_REQUEST_QUERY:
      return {...initialState,
        error: null,
        isLoading: true,
        isUpdating: false,
      };
    case ACTION.LIBRARY_LOADING:
      return {...state,
        error: null,
        isLoading: true,
        isUpdating: false,
      };
    case ACTION.LIBRARY_LOADED:
      return {...state,
        error: null,
        isLoading: false,
        isUpdating: false,
        meettrainer_requests: action.meettrainer_requests,
        totalCount: action.totalCount,
        query: action.query
      };
    case ACTION.FILTER_LOADING:
      return {...state,
        isFilterLoading: true
      };
    case ACTION.FILTER_LOADED:
      return {...state,
        isFilterLoading: false,
        filters: action.filters
      };
    case ACTION.MEETTRAINER_REQUEST_UPDATING:
      return {...state,
        error: null,
        isUpdatiing: true,
      };
    case ACTION.MEETTRAINER_REQUEST_ERROR:
      return {...state,
        error: action.error,
        isLoading: false,
        isUpdating: false,
      };
    default:
      return state;
  }
}